import { useState } from "react";

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            // Append the _subject field so Formspree recognizes it
            const payload = {
                _subject: "New portfolio message for sudhirsharma4500@gmail.com",
                ...formData
            };

            const response = await fetch("https://formspree.io/f/mykbvnbj", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                setResponseMessage("Thank you for reaching out! I will get back to you soon.");
                // Reset form fields back to empty
                setFormData({ name: "", email: "", message: "" });
            } else {
                setResponseMessage("Failed to submit the form. Please try again or email me directly.");
            }
        } catch (error) {
            setResponseMessage("An error occurred. Please try again.");
        } finally {
            setIsSubmitting(false);
            setTimeout(() => setResponseMessage(""), 5000);
        }
    };

    return (
        <section id="contact" className="w-full pt-10 pb-20">
            <h2 className="mb-12 text-center text-4xl font-light text-stone-800 dark:text-stone-200">Get In Touch</h2>
            <div className="max-w-2xl mx-auto bg-white/50 dark:bg-stone-800/50 backdrop-blur-md p-8 md:p-12 rounded-[2rem] shadow-sm border border-stone-200/50 dark:border-stone-700/50 transition-colors duration-300 hover:shadow-md">
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-stone-500 dark:text-stone-400 mb-2">Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            className="w-full px-5 py-4 bg-stone-50 dark:bg-stone-900 border border-stone-200 dark:border-stone-700 rounded-2xl focus:outline-none focus:ring-2 focus:ring-stone-300 dark:focus:ring-stone-600 transition-shadow text-stone-800 dark:text-stone-200 font-light"
                            placeholder="Your Name"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-stone-500 dark:text-stone-400 mb-2">Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="w-full px-5 py-4 bg-stone-50 dark:bg-stone-900 border border-stone-200 dark:border-stone-700 rounded-2xl focus:outline-none focus:ring-2 focus:ring-stone-300 dark:focus:ring-stone-600 transition-shadow text-stone-800 dark:text-stone-200 font-light"
                            placeholder="your.email@example.com"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-stone-500 dark:text-stone-400 mb-2">Message</label>
                        <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                            className="w-full px-5 py-4 bg-stone-50 dark:bg-stone-900 border border-stone-200 dark:border-stone-700 rounded-2xl focus:outline-none focus:ring-2 focus:ring-stone-300 dark:focus:ring-stone-600 transition-shadow text-stone-800 dark:text-stone-200 font-light resize-none"
                            rows="5"
                            placeholder="How can I help you?"
                        ></textarea>
                    </div>
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`w-full py-4 rounded-2xl transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-stone-400 dark:focus:ring-offset-zinc-800 ${isSubmitting
                            ? 'bg-stone-300 dark:bg-stone-700 text-stone-500 cursor-not-allowed'
                            : 'bg-stone-800 dark:bg-stone-200 text-stone-100 dark:text-stone-800 hover:bg-stone-700 dark:hover:bg-white shadow-sm hover:shadow active:scale-[0.98]'
                            } font-medium text-lg`}
                    >
                        {isSubmitting ? "Sending..." : "Send Message"}
                    </button>
                </form>
                {responseMessage && (
                    <p className="mt-6 text-center text-sm font-medium text-stone-600 dark:text-stone-400 animate-pulse">
                        {responseMessage}
                    </p>
                )}
            </div>
        </section>
    );
};

export default ContactForm;
